export default __webpack_public_path__ + "static/media/6.07b4cab3.jpg";